import { ComplianceBlockingRuleDto, ComplianceBlockingRuleUpdateDto } from 'types/compliance';
import { portalAPI } from './portalAPI';

const APIComplianceBlockingRulesSlice = portalAPI
    .enhanceEndpoints({ addTagTypes: ['ComplianceBlockingRules'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getComplianceBlockingRules: builder.query<ComplianceBlockingRuleDto[], void>({
                query: () => '/v1/compliance-blocking-rules',
                providesTags: ['ComplianceBlockingRules'],
            }),
            updateComplianceBlockingRule: builder.mutation<ComplianceBlockingRuleDto, ComplianceBlockingRuleUpdateDto>({
                query: ({ id, ...body }) => ({
                    url: `/v1/compliance-blocking-rules/${id}`,
                    method: 'PUT',
                    body,
                }),
                invalidatesTags: ['ComplianceBlockingRules'],
            }),
        }),
        overrideExisting: false,
    });

export const { useGetComplianceBlockingRulesQuery, useUpdateComplianceBlockingRuleMutation } =
    APIComplianceBlockingRulesSlice;
